import base from '../dr-base'
import drContentHeader from './dr-content-header.vue'

const schema = {
  $Type: 'dr-content-header',
  name: 'Content Header',
  group: 'Common widgets',
  icon: 'pen-alt',
  ...base,
  properties: {
    ...base.properties,
    Icon: { 
      name: 'vuetifyWidgets.dr-content-header.icon',
      type: 'string',
      component: 'dr-icon-picker'
    },
    Title: {
      name: 'vuetifyWidgets.dr-content-header.title', 
      type: 'string',
      component: 'dr-value-editor'
    },
    Subtitle: { 
      name: 'vuetifyWidgets.dr-content-header.subtitle',
      type: 'string',
      component: 'dr-value-editor'
    },
    Actions: {
      name: 'vuetifyWidgets.dr-content-header.actions',
      type: 'string',
      component: 'dr-value-editor'
    },
    ButtonText: {
      name: 'vuetifyWidgets.dr-content-header.buttonText',
      type: 'string'
    }
  }
}

export default {
  schema,
  component: drContentHeader,
  propEditors: [
    {
      name: 'dr-icon-picker'
    }
  ]
}
